module.exports = __webpack_public_path__ + "step4_F2M_kanai_bridal.56e25d14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step4_F2M_kanai_bridal.jpg
// module id = hViz
// module chunks = 0